<template>
  <div class="relative flex flex-col justify-center items-center h-full">
    <section-title titlePath="title-7.png" />
    <p class="w-full max-w-722 font-nunito text-center text-grayish-orange">
      Summonables are little creatures that assist you in battle. Each
      summonable provides unique support and skills, whether it is supportive,
      offensive, or help you acquire more items or Ely. You can train each
      summonable to level up their levels and skills.
    </p>
    <div
      class="w-full max-w-722 flex flex-wrap flex-row justify-center items-center mt-6 z-10"
    >
      <div
        v-for="(summon, index) in summonData"
        :key="index"
        :style="{
          'background-image':
            'url(' + imgPath + '/slide8/summon_' + summon.name + '.png)',
        }"
        class="summon-wrapper w-227 h-252 bg-contain bg-no-repeat bg-center cursor-pointer m-1"
        @click="openSlider(index)"
      ></div>
    </div>
    <img
      class="bow-girl absolute left-0.5/10 bottom-0 invisible xl:invisible"
      :src="`${imgPath}/slide8/summonable_character.png`"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import breakpoints from '@/plugins/breakpoints';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  components: { SectionTitle },
  data: function() {
    return {
      breakpoints,
      imgPath: process.env.VUE_APP_IMG_URL,
    };
  },
  methods: {
    openSlider: function(id) {
      this.$store.commit('SUMMON_SECTION/OPEN_SLIDER', id);
    },
    init_summon_animation: function() {
      this.$store.commit('ANIMATION/INIT_SUMMON_SECTION_INNER');
    },
    disable_summon_animation: function() {
      this.$store.commit('ANIMATION/DISABLE_SUMMON_SECTION_INNER');
    },
  },
  computed: {
    ...mapState({
      activeSection: state => state.Fullpage.activeSection,
      summonData: state => state.SummonSection.summonData,
    }),
  },
  created: function() {
    this.unwatch = this.$store.watch(
      (state, getters) => getters.activeSection,
      (newValue, oldValue) => {
        //console.log(`Updating from ${oldValue} to ${newValue}`);
        if (newValue === 7 && this.breakpoints.w > 1366) {
          this.init_summon_animation();
        } else if (newValue != 7 && this.breakpoints.w > 1366) {
          this.disable_summon_animation();
        }
      },
    );
  },
  beforeDestroy() {
    this.unwatch();
  },
};
</script>

<style lang="postcss" scoped>
.summon-wrapper:hover {
  transform: translateY(-8px);
  transition: all 0.2s ease-in;
}
.summon-wrapper {
  transform: translateY(0);
  transition: all 0.2s ease-out;
}
</style>
